import axios from 'axios';
import qs from 'querystring';

/**
 * Retrieves an MPG key from the server that can be used to make calls to MPG.
 * 
 * @param {object} params 
 */
 export async function getMpgKey(params) {

    const config = {
        method: 'GET',
        url: '/public/user-registration/mpg/getKey',
        headers: {
            'Content-Type': 'application/json'
        },
        params: params
    };

    return await axios.request(config).then((response) => {
        return response;
    }, (error) => {
        console.error(error);
        return error;
    });

}

/**
 * Registers a credit card with MPG.
 * 
 * @param {object} data 
 */
 export async function createMpgCreditCard(data) {

    const requestBody = {
        mpg_key: data.mpgInfo.key,
        mpg_target: data.mpgInfo.mpgReturnURL,
        mpg_no_target_redirect: true,
        mpg_cc_type: data.ccInfo.mpgCardtype,
        mpg_cc_num: data.ccInfo.cardNumber,
        mpg_cc_exp_year: data.ccInfo.expirationYear,
        mpg_cc_exp_month: data.ccInfo.expirationMonth,
        mpg_cc_holder_name: data.ccInfo.cardHolderName,
        mpg_cc_cvc: data.ccInfo.securityCode
    }

    const config = {
        method: 'POST',
        url: data.mpgInfo.mpgURL,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: qs.stringify(requestBody)
    };

    return await axios.request(config).then((response) => {
        return response;
    }, (error) => {
        return error;
    });

}

/**
 * In the event of an MPG create credit card failure, this method can be invoked to inform the server.
 * 
 * @param {number} userRegistrationId 
 */
 export async function registerCreateFailEvent(userRegistrationId) {

    // Now prepare to save the model.
    const config = {
       method: 'POST',
       url: '/public/user-registration/' + userRegistrationId + '/events/mpg-create-failure',
       headers: {
           'Content-Type': 'application/json'
       }
   }

   return await axios.request(config).then((response) => {
       return response;
   }).catch((error) => {
       console.error(error);
       return error;
   });

}

export async function callManualMpgRedirect(redirectInfo) {

    const config = {
        method: 'POST',
        url: redirectInfo.url,
        headers: {
            'Content-Type': 'application/json'
        },
        data: redirectInfo.data
    };

    return await axios.request(config).then((response) => {
        return response;
    }, (error) => {
        console.error(error);
        return error;
    });

}